<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">安全验证</span>
      <Reback class="row-one-fr" @click.native="reback"></Reback>
    </el-row>
    <el-form :model="verificationForm" :rules="verificationFormRules" ref="verificationFormRef" label-width="100px" label-position="right" class="form-single">
      <el-form-item label="银行卡：" class="margin-t50">
        <span class="form-single-sp">{{verificationForm.card}}</span>
      </el-form-item>
      <el-form-item label="手机号：" prop="phone" :error="phoneError">
        <el-input v-model="verificationForm.phone" placeholder="预留手机号">
          <el-button :disabled="codeDisable" type="code" slot="append" @click="getCode">
            <span v-show="sendAuthCode">{{this.codefont == '0'? '获取验证码':'重新获取'}}</span>
            <span v-show="!sendAuthCode">{{auth_time}} 秒</span>
          </el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <el-input v-model="verificationForm.code" placeholder="请输入6位验证码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="normal" @click="submit">{{submitText}}</el-button>
      </el-form-item>
    </el-form>
    <section class="instruction margin-t70">
      <div class="instruction-li">
        <p class="instruction-li-title">温馨提示</p>
        <p class="instruction-li-con">
          为了您的资金安全，请输入银行预留手机号及验证码进行身份认证。<br>
        </p>
      </div>
    </section>
  </div>
</template> 

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      verificationForm: {
        phone: '',
        code: '',
        card: ''
      },
      verificationFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      phoneError: '',
      loginInfo: '',
      cardInfo: '',
      auth_time: 0,
      codeDisable: false,
      sendAuthCode: true,
      codefont: 0,
      submitText: '确认',
      token: '', // 入参
      routeMessage: '',
      fundMessage: '',
    }
  },
  created () {
    this.fundMessage = this.$route.params.fundMessage
    this.verificationForm.card = this.$route.params.id
    this.routeMessage = this.$route.params
    // console.log(this.routeMessage);
  },
  mounted () {
    this.getData()
  },
  methods: {
    reback () {
      if (this.routeMessage.name == 'recharge') {
        this.$router.push({ name: 'recharge' })
      } else if (this.routeMessage.name == 'combinationBuy') {
        this.$router.push({ name: 'combinationBuy' })
      } else if (this.routeMessage.name == 'publicBuy') {
        this.$router.push({
          name: 'publicBuy',
          params: {
            fundMessage: this.fundMessage
          }
        })
      } else if (this.routeMessage.name == 'publicRecord') {
        this.$router.push({ name: 'publicRecord' })
      }
    },
    counter () {
      this.codeDisable = true
      this.sendAuthCode = false;
      this.auth_time = 90;
      var auth_timetimer = setInterval(() => {
        if (this.auth_time == 0) {
          this.sendAuthCode = true;
          this.codeDisable = false
          clearInterval(auth_timetimer);
          this.codefont = 1
        } else {
          this.auth_time--;
        }
      }, 1000);
    },
    // 获取验证码
    getCode () {
      if (this.verificationForm.phone == '') {
        this.phoneError = '预留手机号不能为空'
      } else {
        this.$http.post(this.$apiPath.identifySend, {
          cardflag: '',//区别开户验卡流程,增卡值为1否则为空
          mobileno: this.verificationForm.phone,//手机号码
          depositacctname: Base64.decode(this.$commonJs.getCookie('u_name1')),
          certificatetype: '0',
          certificateno: this.loginInfo.custInfo.certificateno,//证件号码
          channelname: this.cardInfo.channelname,
          paycenterid: this.cardInfo.paycenterid,
          depositacct: this.cardInfo.depositacct,
          channelid: this.cardInfo.channelid,
          keep_phone_num1: this.verificationForm.phone,
        }).then(res => {
          if (res.status !== 200) return
          if (res.data.code == "200") {
            var code = res.data.data.code
            var msg = res.data.data.msg
            if (code == "0000") {//成功接收
              this.counter();
              this.token = res.data.data.token
            } else if (code == "1001") {
              // console.log(msg);
              this.phoneError = '您的银行卡已签约，请返回重新购买'
            }
          } else {
            this.phoneError = res.data.message
          }
        }).catch(err => { })
      }
    },
    submit () {
      this.$refs.verificationFormRef.validate(valid => {
        if (!valid) return
        this.submitText = '确认中...'
        this.$http.post(this.$apiPath.verifySend, {
          keep_phone_num1: this.verificationForm.phone,// 预留手机号
          keep_phone_code_num1: this.verificationForm.code,//预留手机号验证码
          depositacctname: this.loginInfo.custInfo.depositacctname,//真实姓名，登录后保存的用户信息中取值）
          certificatetype: '0',//证件类型
          certificateno: this.loginInfo.custInfo.certificateno,//证件号码，登录后保存的信息中取的身份证号)
          familyname: '',
          firstname: '',
          mobileno: this.verificationForm.phone,//预留手机号
          email: '123456@163.com',
          minorid: '',
          referral: this.loginInfo.custInfo.referral,// 服务代码
          referralmobile: '',
          custmanagerid: '',
          depositacct: this.verificationForm.card,// 银行卡号
          custfullname: this.loginInfo.custInfo.depositacctname,// 客户全称
          address: '',
          postcode: '',
          vailddate: '',//（证件有效期，从登录后保存的信息中获取，旧接口固定传参"20591231"
          channelname: this.cardInfo.channelname,//（银行卡类型，从登录后保存的信息中获取）
          telno: '',
          officetelno: '',
          minorflag: '',
          fax: '',
          country: '',
          sex: '',
          educationlevel: '',
          vocationcode: '',
          annualincome: '',
          szsecuritiesaccountid: '',
          shsecuritiesaccountid: '',
          referralprovincename: '',
          referralcityname: '',
          ismainback: '',
          ismainpay: '',
          nickname: '',
          hometelno: '',
          transactorcerttype: '',
          transactorcertno: '',
          transactorname: '',
          transactorvalidate: '',
          transactorcertrefer: '',
          transactortel: '',
          signflag: '1',
          channelid: this.cardInfo.channelid,//银行卡信息中获取 银联？通联？
          paycenterid: this.cardInfo.paycenterid,//银行名称ID
          token: this.token,//token
        }).then(res => {
          //   console.log('结果', res);
          if (res.status !== 200) return
          if (res.data.code == "0000" || res.data.code == "200") {//成功
            this.reback()
          } else {
            if (res.data.code == "9901") {
              this.$message.error("校验失败！");
              this.submitText = '确认'
            } else if (res.data.code == "B.MGW.0120") {
              this.$message.error("验卡失败！");
              this.submitText = '确认'
            } else if (res.data.code == "60" || res.data.code == "66" || res.data.code == "35" || res.data.code == "02") {
              this.$message.error("未知错误，请核对信息无误后重新操作");
              this.submitText = '确认'
            } else {
              if ((res.data.code != "1001") && (res.data.code != "300030")) {
                this.$message.error(res.data.message);
                this.submitText = '确认'
              } else {
                this.reback() //支付
              }
            }
            return;
          }
        }).catch(err => { })
      })
    },
    // 全局数据
    getData () {
      this.$http.post(this.$apiPath.sessionId, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.loginInfo = res.data.data
        res.data.data.bankCardInfo.forEach(item => {
          if (this.verificationForm.card == item.depositacct) {
            this.cardInfo = item
          }
        });
      }).catch(error => { })
    },
  }
}
</script>
